import { createSlice } from "@reduxjs/toolkit";


const planningSlice = createSlice({
  name: "planning",
  initialState: {
    modalVisible: false,
    modalThingId: [],
    checkData:false,
    isAssignReplacement:false,
  },
  reducers: {
    setModalVisible: (state, action) => {
      state.modalVisible = action.payload;
    },
    setAssignReplacement: (state, action) => {
      state.isAssignReplacement = action.payload;
    },
    setCheckData: (state, action) => {
      state.checkData = action.payload;
    },
    setModelThing: (state,action) => {
      state.modalThingId= action.payload;
    },
  },
});

export const { setModelThing, setModalVisible ,setCheckData,setAssignReplacement} = planningSlice.actions;
export default planningSlice.reducer;
